import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faMagnifyingGlass, faWallet, faCreditCard, faArrowUpFromBracket, faUsd, faArrowRight, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Select from "react-select";
import WithdrawHistory from "../components/WithdrawHistory";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useLocation, Link } from 'react-router-dom'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function Withdraw() {
  const { user } = useUser();
  const { state } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          value: coin.name,
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [activeTab1, setActiveTab1] = useState("all");
  const savedRoute = localStorage.getItem('withdraw.route');
  const [route, setRoute] = useState(
    state?.route ?? savedRoute ?? 'assets'
  );
  const routes = [
    { 
      value: "assets", 
      label: "Assets", 
    },
    { 
        value: "loan", 
        label: "Loan Balance", 
    },
  ];
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [withdrawhistorys, setWithdrawhistorys] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All" },
    { value: "success", label: "Success" },
    { value: "pending", label: "Pending" },
    { value: "failed", label: "failed" },
  ];
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwith: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          if (
            coinName === "Bank Transfer" ||
            coinName === "Paypal" ||
            coinName === "Skrill"
          ) {
            logo = `/uploads/usd.svg`;
            symbol = "USD";
          } else {
            const asset = crypto.find(asset => asset.name === coinName);
            if (asset) {
              logo = asset.logo;
              symbol = asset.symbol;
            }
          }
          return {
            ...tx,
            logo,
            symbol
          };
        });
        setWithdrawhistorys(updatedTrans);
      }
    })
    .catch(err => {
        console.error('Error fetching withdraw transaction!')
    })
  }, [user]);
  const filteredHistory = withdrawhistorys.filter(deposithistory => 
    Object.values(deposithistory).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) && 
    (selectedFilter === 'all' || deposithistory.status.toLowerCase() === selectedFilter.toLowerCase())
  )
  const exportTableToPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, { html: '#history-table' });
    doc.save('history.pdf');
  };
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if(route){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [route]);
  
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Withdraw" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Withdraw" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Withdraw Funds</h5>
                        <p className="mb-0">Withdraw from from your account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/withdraw" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                                <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Withdrawal Account</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Method Selection</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Withdrawal Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Withdrawal Code</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-0" style={{fontWeight:'900'}}>Route Deposit To:</h5>
                              <div className="row">
                                {routes.map((options, index) => {
                                return (
                                <div className="col-md-6 g-3">
                                  <div className={`mycard p-3 d-flex align-items-center ${state?.route && state?.route == options.value?null:state?.route?'disabled':null}`} onClick={() => state?.route?null:setRoute(options.value)} style={{border:route == options.value ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                      <FontAwesomeIcon icon={faUsd} style={{fontSize: '18px'}} className="text-prime" />
                                    </div>
                                    <div className="ms-3">
                                      <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{options.label}</p>
                                      <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                        {options.value === "assets" ? (
                                          <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>
                                            All available assets.
                                          </p>
                                        ) : options.value === "loan" ? (
                                          <>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>
                                              Available Bal.
                                            </p>
                                            <div className="rounded-circle bg-secondary" style={{ width: '3px', height: '3px' }}></div>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>
                                              {getCurrencySymbol(user?.currency)}
                                              {formatCurrency(Number(user?.loan_balance) * rate)}
                                            </p>
                                          </>
                                        ) : null
                                      }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                )})}
                              </div>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/withdraw1" state={{route : route}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => {
                                      localStorage.setItem('withdraw.route', route);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="d-flex align-items-center justify-content-between flex-wrap mb-3" style={{gap:'10px'}}>
                            <div className="d-flex align-items-cemter overflow-x-auto mx-2" style={{cursor:'pointer'}}>
                                <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab1 === "pending" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab1 === "pending" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab1("pending");}}>Pending Withdraws</h6>
                                <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab1 === "all" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab1 === "all" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab1("all");}}>All Withdraws</h6>
                            </div>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                              <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                <input 
                                  type="text" 
                                  placeholder="Search for withdrawals" 
                                  className="searchinput"
                                  value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                />
                              </div>
                              <Select 
                                options={filteroptions}
                                value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                onChange={(e) => setSelectedFilter(e.value)}
                                styles={darkThemeStyles}
                                className="w-full"
                              />
                            </div>
                        </div>
                        {activeTab1 === "pending" && (
                        <div className="mycard">
                            <div className="table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                          <th className="fw-normal text-light">ID</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Date</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Reference</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                                          <th className="fw-normal text-light">Amount</th>
                                          <th className="fw-normal text-light">Status</th>
                                          <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredHistory.length > 0 ? (
                                        filteredHistory.map((history, index) =>
                                            history?.status === "pending" ? (
                                                <WithdrawHistory key={history.id || index} index={index} history={history} />
                                            ) : null
                                        )
                                    ) : (
                                        <tr>
                                            <td className="py-5" colSpan={7}>You have not made any withdrawals yet.</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        )}
                        {activeTab1 === "all" && (
                        <div className="mycard">
                            <div className="myBtn bg-prime px-3 ms-2 d-inline-block mb-2" onClick={exportTableToPDF}>Export</div>
                            <div className="table-responsive">
                                <table id="history-table" className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                          <th className="fw-normal text-light">ID</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Date</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Reference</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                          <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                                          <th className="fw-normal text-light">Amount</th>
                                          <th className="fw-normal text-light">Status</th>
                                          <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredHistory.length > 0 ? (
                                        filteredHistory.map((history, index) => (
                                            <WithdrawHistory index={index} history={history}/>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="py-5" colSpan={7}>You have not made any withdrawals yet.</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Withdraw